import { i18n } from "../i18n";

const Trans = {
  get defaultLocale() {
    return "en";
  },
  get supportedLocales() {
    return "es,en".split(",");
  },
  get currentLocale() {
    return i18n.locale;
  },
  set currentLocale(locale) {
    i18n.locale = locale;
  },
  setI18nLocaleInServices(locale) {
    Trans.currentLocale = locale;
    return locale;
  },
  changeLocale() {
    let language = document.querySelector("html").getAttribute("lang");
    console.log(language);
    language = language.split("-")[0]
    return Trans.loadLocaleFile(language).then((msgs) => {
      i18n.setLocaleMessage(language, msgs.default || msgs);
      return Trans.setI18nLocaleInServices(language);
    });
  },
  loadLocaleFile(locale) {
    return import(`../locales/${locale}.json`);
    
  },
  i18nRoute(to) {
    return {
      ...to,
      params: {
        locale: this.currentLocale,
        ...to.params,
      },
    };
  },
};

export { Trans };
